
import { useParams } from 'react-router-dom';
import { useContext, useState } from 'react';
import UserContext from '../contexts/ContextApi';
import Header from '../Components/InitialPage/Header';
import { Button, Container, Destiny, Image, Packet } from '../GlobalStyle/PackCSS';
import styled from 'styled-components';
import checkPreto from '../Assets/CheckPreto.jpg';
import Slogan from '../Components/InitialPage/Slogan';
import Footer from '../Components/InitialPage/Footer';


export default function UniquePack() {
    const { id } = useParams(); // Obtém o parâmetro 'id' da rota
    const { packs } = useContext(UserContext); // Obtém os pacotes do contexto
    const [name, setName] = useState("");
    const [origin, setOrigin] = useState("");
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [days, setDays] = useState(0);
    const [luggage, setLuggage] = useState(false);
    const [luggageCount, setLuggageCount] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
    const { setPackSelect, setPackId } = useContext(UserContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
    const [destiny, setDestiny] = useState('');
    const [isOrderSent, setIsOrderSent] = useState(false);

    console.log(id);

    // Encontra o pacote com o id correspondente
    const pack = packs.find(pack => pack.id === Number(id));

    if (!pack) {
        return <div>Pacote não encontrado.</div>;
    }


    function reservarPack() {
        setPackSelect(pack.destiny);
        setPackId(pack.id);
        setIsModalOpen(true);
        setDestiny(pack.destiny)
    }

    function closeModal() {
        setIsModalOpen(false);
    }

    function handleBackgroundClick(e) {
        if (e.target.id === 'modal-background') {
            closeModal();
        }
    }

    function orderPack(e) {
        e.preventDefault();
        let luggageStatus;
        if (luggage === false) {
            luggageStatus = "Não";
        } else {
            luggageStatus = "Sim";
        }

        let message =
            `    Informações de contato:
  NOME: ${name}
  PASSAGEIROS:
  ADULTO: ${adults}
  CRIANÇA: ${children}
  ORIGEM: ${origin}
  DESTINO: ${destiny}
  MÊS: ${selectedMonth}
  DIAS: ${days}
  BAGAGEM DESPACHADA: ${luggageStatus}
  QUANTAS: ${luggageCount}`;
        console.log(message);
        const encode = encodeURIComponent(message);
        window.open(`https://wa.me/5532984957373?text=${encode}`);
        setIsOrderSent(true);
        setIsModalOpen(false); // Fechar o modal de pedido
        setIsThankYouModalOpen(true); // Abrir o modal de agradecimento
        setName("");
        setOrigin("");
        setAdults(0);
        setChildren(0);
        setDays(0);
        setLuggage(false);
        setLuggageCount(0);
        setSelectedMonth('');
        setIsMonthDropdownOpen(false);
    }

    function handleThankYouModalBackgroundClick(e) {
        if (e.target.id === 'modal-background-thank-you') {
            setIsThankYouModalOpen(false);
        }
    }

    const months = [
        'JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO',
        'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'
    ];

    function toggleMonthDropdown() {
        setIsMonthDropdownOpen(!isMonthDropdownOpen);
    }

    function selectMonth(month) {
        setSelectedMonth(month);
        setIsMonthDropdownOpen(true);
    }

    const handleSwapCities = () => {
        const temp = origin;
        setOrigin(destiny);
        setDestiny(temp);
    };

    return (
        <Contain>
            <Header />
            <Slogan />
            <Packet>
                <Image img={pack.image}>
                    <div>{pack.price}</div>
                </Image>
                <Destiny><div>{pack.destiny}</div></Destiny>
                <Container destiny={pack.destiny}>
                    {pack.destiny === 'PORTUGAL' ? <div><img src="https://static.vecteezy.com/ti/vetor-gratis/p3/554188-de-asterisco-gratis-vetor.jpg" alt="asterisco" /> <h1>{pack.ticket}</h1></div> : <div><img src={checkPreto} alt="check" /> <h1>{pack.ticket}</h1></div>}
                    <div><img src={checkPreto} alt="check" /> <h1>{pack.departureTax}</h1></div>
                    <div><img src={checkPreto} alt="check" /> <h1>{pack.baggage}</h1></div>
                    <div><img src={checkPreto} alt="check" /> <h1>{pack.support}</h1></div>
                    <div><img src={checkPreto} alt="check" /> <h1>{pack.bilhete}</h1></div>
                </Container>
                <Button onClick={reservarPack}><div>GARANTA SUA RESERVA</div></Button>
            </Packet>
            {isModalOpen && (
                <ModalBackground id="modal-background" onClick={handleBackgroundClick}>
                    <Modal>
                        {/* <CloseButton onClick={closeModal}>X</CloseButton> */}
                        <Form onSubmit={orderPack}>
                            <h1>Olá, viajante!</h1>
                            <h2>Preencha os campos abaixo de acordo com suas preferêcias:</h2>
                            <SubTitles>Seu nome:</SubTitles>
                            <label style={{ display: 'flex' }}>
                                <input style={{ borderRadius: '30px', border: 'none', width: '100%' }} type="text" name="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)} required />
                            </label>
                            <div>
                                <label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <SubTitles>
                                            <span>Passageiros: </span>
                                        </SubTitles>
                                        <SubTitles style={{ marginLeft: '10px' }}>
                                            <span >Adultos:</span>
                                        </SubTitles>
                                        <Counter>
                                            <ButtonLeft style={{ textDecoration: 'none' }} type="button" onClick={() => setAdults(Math.max(0, adults - 1))}>-</ButtonLeft>
                                            <span>{adults}</span>
                                            <ButtonRight style={{ marginRight: '5px' }} type="button" onClick={() => setAdults(adults + 1)}>+</ButtonRight>
                                        </Counter>
                                        <SubTitles>Crianças:</SubTitles>
                                        <Counter>
                                            <ButtonLeft style={{ marginLeft: '5px' }} type="button" onClick={() => setChildren(Math.max(0, children - 1))}>-</ButtonLeft>
                                            <span>{children}</span>
                                            <ButtonRight style={{ marginRight: '5px' }} type="button" onClick={() => setChildren(children + 1)}>+</ButtonRight>
                                        </Counter>
                                    </div>
                                </label>
                            </div>
                            <Cities>
                                <label style={{ display: 'flex', flexDirection: 'column' }}>
                                    <SubTitlesCity>Cidade de origem:</SubTitlesCity>
                                    <City type="text" name="origin" value={origin} onChange={(e) => setOrigin(e.target.value)} required />
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <ion-icon name="swap-horizontal-outline" onClick={handleSwapCities}></ion-icon>
                                </div>
                                <label style={{ display: 'flex', flexDirection: 'column' }}>
                                    <SubTitlesCity>Cidade de destino:</SubTitlesCity>
                                    <City type="text" name="destination" value={destiny} readOnly />
                                </label>
                            </Cities>
                            <div>
                                <SubTitles> Mês da viagem: </SubTitles>
                                <label style={{ display: 'flex', position: 'relative', width: '85px' }}>
                                    <input
                                        type="text"
                                        name="travelMonth"
                                        value={selectedMonth}
                                        onClick={toggleMonthDropdown}
                                        readOnly
                                        required
                                        placeholder=""
                                        style={{
                                            cursor: 'pointer', width: '85px', border: 'none',
                                            borderRadius: '30px', display: 'flex', paddingLeft: '5px', height: '18px',
                                            fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '10px',
                                            backgroundImage: 'url(https://cdn-icons-png.flaticon.com/512/271/271210.png)',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: '70px center',
                                            backgroundSize: '15px'
                                        }}

                                    />
                                    {isMonthDropdownOpen && (
                                        <MonthDropdown>
                                            {months.map((month, index) => (
                                                <MonthItem key={index} onClick={() => selectMonth(month)}>
                                                    {month}
                                                </MonthItem>
                                            ))}
                                        </MonthDropdown>
                                    )}
                                </label>
                            </div>
                            <div>
                                <label>
                                    <SubTitles>Quantos dias pretende ficar?</SubTitles>
                                    <Counter>
                                        <ButtonLeft type="button" onClick={() => setDays(Math.max(0, days - 1))}>-</ButtonLeft>
                                        <span>{days}</span>
                                        <ButtonRight type="button" onClick={() => setDays(days + 1)}>+</ButtonRight>
                                    </Counter>
                                </label>
                            </div>
                            <div>
                                <label>
                                    <SubTitles>Bagagem despachada (23kg)?</SubTitles>
                                    <div>
                                        <input
                                            type="radio"
                                            name="luggage"
                                            value="yes"
                                            checked={luggage}
                                            onChange={() => setLuggage(true)}
                                        /> Sim
                                        <input
                                            type="radio"
                                            name="luggage"
                                            value="no"
                                            checked={!luggage}
                                            onChange={() => setLuggage(false)}
                                        /> Não
                                    </div>
                                </label>
                                {luggage && (
                                    <label style={{ marginTop: '5px' }}>
                                        <SubTitles>Quantas:</SubTitles>
                                        <Counter>
                                            <ButtonLeft type="button" onClick={() => setLuggageCount(Math.max(0, luggageCount - 1))}>-</ButtonLeft>
                                            <span>{luggageCount}</span>
                                            <ButtonRight type="button" onClick={() => setLuggageCount(luggageCount + 1)}>+</ButtonRight>
                                        </Counter>
                                    </label>
                                )}
                            </div>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <button style={{
                                    border: 'none', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '13px',
                                    width: '61px', height: '30px', borderRadius: '30px', textAlign: 'center', padding: '5px'
                                }}
                                    type="submit">ENVIAR</button>
                            </div>
                        </Form>
                    </Modal>
                </ModalBackground>
            )}
            {isThankYouModalOpen && (
                <ModalThank id="modal-background-thank-you" onClick={handleThankYouModalBackgroundClick}>
                    <MiniModal>
                        <h1>OBRIGADO!</h1>
                        <h2>Nossa equipe já está buscando as <span>melhores opções</span> para você! :)</h2>
                        <h3>Aguarde que logo menos um de nossos agentes entrará em contato atráves do número fornecido.</h3>
                        <h4>Enquanto isso, vem acompanhar nossas redes: </h4>
                        <div>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Instagram_logo.png/768px-Instagram_logo.png" alt="insta" />
                            <img src="https://freepngtransparent.com/wp-content/uploads/2023/03/tiktok-png-158.png" alt="tiktok" />
                        </div>
                    </MiniModal>
                </ModalThank>
            )}
            <Footer/>
        </Contain>
    );
};

const Contain = styled.div`
display: flex;
flex-direction: column;
align-items: center;
`;

const ModalBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`;

const ModalThank = styled.div`
 position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`;

const MiniModal = styled.div`
        background: #214488;
    padding: 20px;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    color: white;
    font-family: "Montserrat", sans-serif;
    div{
width: 100px;
height: 30px;
display: flex;
align-items: center;
justify-content: space-around;
img{
    width: 30px;
}
    }
    @media (min-width: 760px) {
    margin-top:-200px;
}
@media (min-width: 850px) and (min-height: 1200px) {
    top: -280px;
}
@media (min-width:900px) {
    width: 500px;
    height: 250px;
    top: 100px;
    text-align: center;
    h1{
        font-size: 50px;
        font-weight: bold;
    }
    h2{
        font-size: 25px;
        span{
            font-weight: bold;
        }
    }
    h4{
        font-size: 25px;
    }
}
`;

const Modal = styled.div`
    background: #214488;
    padding: 20px;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 435px;
    gap: 10px;
    border-radius: 50px;
    @media (min-width: 760px) {
    margin-top:-200px;
}
@media (min-width: 850px) and (min-height: 1200px) {
    top: -280px;
}
@media (min-width:900px) {
    width: 500px;
    height: 435px;
    top: 100px;
}
`;

// const CloseButton = styled.button`
//     position: absolute;
//     top: 10px;
//     right: 10px;
//     background: none;
//     border: none;
//     font-size: 1.5rem;
//     cursor: pointer;
// `;

const Counter = styled.div`
    display: flex;
    align-items: center;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 20px;
    }
    span {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        color: black;
    }
`;

const Form = styled.form`
color:white;
font-family: "Montserrat", sans-serif;
font-size: 10px;
h1{
    font-size:40px;
    font-weight: bold;
    margin-bottom:5px;
    @media(min-width:900px){
        font-size: 50px;
    }
}
h2{
    font-size: 15px;
    margin-bottom:10px;
    @media(min-width:900px){
     font-size:15px ;
    }

}
div{
    margin-top: 5px;
}
label{
    margin-top: 5px;
}
input{
    @media(min-width:900px){
        height: 25px;
    }
}
`;

const ButtonLeft = styled.button`
margin-left: 5px;
border: none;
border-right: 1px solid black;
width: 10px;
background-color: white;
`;

const ButtonRight = styled.button`
border: none;
border-left: 1px solid black;
width: 10px;
background-color: white;
`;

const MonthDropdown = styled.div`
    position: absolute;
    top: 15px;
    left: 0;
    background: white;
    border: 1px solid #ccc;
    width: 80px;
    color:black;
    z-index: 1000;
`;

const MonthItem = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
    cursor: pointer;
    &:hover {
        background-color: #f1f1f1;
    }
`;

const SubTitles = styled.h3`
 border-bottom: 2px solid white; 
 display: inline-block; 
 padding-bottom: 0px;
 font-size: 13px;
 @media(min-width:900px){
     font-size:15px;
     white-space: nowrap;
    }
`;

const City = styled.input`                                   
width: 200px;
border: none;
border-radius: 30px; 
margin-top: 5px;                                      
font-family: "Montserrat", sans-serif; 
font-weight: bold;
font-size: 13px;
@media(min-width:900px){
    width: 200px;
}
`;

const SubTitlesCity = styled.h3`
 border-bottom: 2px solid white; 
 display: inline-block; 
 padding-bottom: 0px; 
 width:125px;
 font-size: 13px;
 @media(min-width:900px){
     font-size:15px;
     white-space: nowrap;
     width:140px;
    }
`;

const Cities = styled.div`
display: flex;
justify-content: space-between;
flex-direction:column;
@media(min-width:900px){
    flex-direction: row;
}
ion-icon[name='swap-horizontal-outline'] {
  width: 30px;
  height:30px;
  margin-top: 15px;
}
`;